import { render, staticRenderFns } from "./LiveBids.vue?vue&type=template&id=447af82b&scoped=true"
import script from "./LiveBids.vue?vue&type=script&lang=js"
export * from "./LiveBids.vue?vue&type=script&lang=js"
import style0 from "./LiveBids.vue?vue&type=style&index=0&id=447af82b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447af82b",
  null
  
)

export default component.exports